import type { Theme } from '@mui/material/styles';

const Menu = (theme: Theme) => {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
};

export default Menu;
